// @flow
import * as React from 'react';
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
//import ButtonNextPage from 'components/ButtonNextPage';
import {BackgroundImage} from 'components/Image'
import {
  Paragraph,
  useLocalized,
} from 'components/Localized';
import Logo from 'components/Logo';
import GuideMessageContainer from 'components/GuideMessageContainer';
import GuideMessageCenter from 'components/GuideMessageCenter';
import * as VRUtils from 'utils/vrUtils';
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer'
import ButtonNextPage, {ButtonNextItem} from 'components/ButtonNextPage';
import SoundToggleButton from 'components/SoundToggleButton';

type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
  onSkip: () => void,
};


export default function ChargingStationC(props: Props): React.Element<any> {
  const localized = useLocalized();
  const [page, setPage] = React.useState(0);

  console.log("ChargingStationC:", page);
  const key1 = "ChargingStationC_buttonSpot1";
  const refCallback1 = VideoUtils.CreateAddPointCallback(key1, 0.3867056405345481 , 0.6631668184432515);

  const key2 = "ChargingStationC_buttonSpot2";
  const refCallback2 = VideoUtils.CreateAddPointCallback(key2, 0.7203045426250287 , 0.5609494035685646);
  
  const [B02_2_played, setB02_2_played] = React.useState(false);


  const handleNextPage = React.useCallback(() => {
    if (page === 0) {
      window.tagManager.chargingStationDragPluginNextLinkClick();
    }
    if (page === 2) {
      window.tagManager.chargingStationDragPluginRecliningSeatLinkClick();
    }
    if (page >= 2) {
      //props.onNext();
      setPage(page + 1);
      VRUtils.ready(function(){
        VideoUtils.loadB02_3();
        VideoUtils.onEnd(props.onNext);
        VideoUtils.play();

      });

    }
    else {
      if (page + 1 === 2) {
        VideoUtils.loadB02_2();
        VideoUtils.play();
      }

      setPage(page + 1);
    }

  }, [page, props]);
  React.useEffect(()=>{
    VideoUtils.loadB02_2();
  }, []);

  return (
    <main>
      <GuideMessageContainer onClick={() => setPage(1)}>
        <GuideMessageCenter show={page === 0} localText={localized.driving_b02_charging_041}>
        </GuideMessageCenter>
      </GuideMessageContainer>
      <div>
        {page === 1 &&
        <GuidePoint1 ref={refCallback1} onClick={() => {
          window.tagManager.chargingStationDragPluginRoominessLinkClick();
          setPage(2);
          console.log("click guidepoint1 to page2");
          VideoUtils.loadB02_2();
          VideoUtils.onEnd(()=>{
            setB02_2_played(true);
          });
          VideoUtils.play();
        } }
        >
          <BackgroundImage source="./driving-zone/b/bnt-b-roominess.png">
            <Paragraph textKey="driving_b02_charging_051" />
          </BackgroundImage>
          <SpotGuide source="./driving-zone/b/img-touch-finger.png" className="effectBlinkSoft" />
        </GuidePoint1>
        }
        {page === 2 && B02_2_played && 
        <GuidePoint2 ref={refCallback2} onClick={handleNextPage}>
          <BackgroundImage source="./driving-zone/b/bnt-b-reclining-seat.png">
            <Paragraph textKey="driving_b02_charging_052" />
          </BackgroundImage>
          <SpotGuide2 source="./driving-zone/b/img-touch-finger.png" className="effectBlinkSoft" />
        </GuidePoint2>
        }
      </div>
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />

      <ButtonNextPage>
        
        {page === 0 && <ButtonNextItem title={localized.button_next} onNext={handleNextPage} />}
      </ButtonNextPage>
      <Logo />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const GuidePoint1 = styled.button`
  position: absolute;
  left: calc(${(props) =>  - (props.theme.layout.mobile ? 230 : 306)}px -  ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-left)")} );
  top: calc(${(props) => - (props.theme.layout.mobile ? 5 : 5)}px - ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-top)")} );


  >:first-child {
    width: ${props => props.theme.layout.mobile ? 230 : 306}px;
    height: ${props => props.theme.layout.mobile ? 70 : 105}px;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    p {
      padding-left: ${props => props.theme.layout.mobile ? 20 : 27}px;
      padding-right: ${props => props.theme.layout.mobile ? 60 : 92}px;
      padding-top: ${props => props.theme.layout.mobile ? 42 : 71}px;
      text-align: center;
    }
  }
`;

const GuidePoint2 = styled.button`
  position: absolute;

  left: calc(${(props) =>  - (props.theme.layout.mobile ? 284 : 422)}px -  ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-left)")} );
  top: calc(${(props) => - (props.theme.layout.mobile ? 73 : 149)}px - ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-top)")} );

  >:first-child {
    width: ${props => props.theme.layout.mobile ? 284 : 422}px;
    height: ${props => props.theme.layout.mobile ? 73 : 149}px;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    p {
      padding-left: ${props => props.theme.layout.mobile ? 27 : 27}px;
      padding-right: ${props => props.theme.layout.mobile ? 80 : 167}px;
      padding-top: ${props => props.theme.layout.mobile ? 8 : 11}px;
      text-align: center;
    }
  }
`;

const SpotGuide = styled(BackgroundImage)`
  position: absolute;
  left: ${props => props.theme.layout.mobile ? 81 : 79}px;
  top: ${props => props.theme.layout.mobile ? 48 : 83}px;
  width: ${props => props.theme.layout.mobile ? 45 : 71}px;
  height: ${props => props.theme.layout.mobile ? 74 : 118}px;
`;

const SpotGuide2 = styled(BackgroundImage)`
  position: absolute;
  left: ${props => props.theme.layout.mobile ? 95 : 101}px;
  top: ${props => props.theme.layout.mobile ? 22 : 25}px;
  width: ${props => props.theme.layout.mobile ? 45 : 71}px;
  height: ${props => props.theme.layout.mobile ? 74 : 118}px;
`;
